import { create } from "zustand"
import { ShelfItemBookEntity } from "@/app/entities/ShelfEntity"
import { BookSelectionState, AnalysisStatus } from "../_types"

interface BookshelfExtractStore extends BookSelectionState {
  // State
  analysisStatus: AnalysisStatus
  
  // Actions
  setSelectedBooks: (books: Set<string>) => void
  toggleBookSelection: (isbn: string) => void
  setLoading: (loading: boolean) => void
  setError: (error: string | null) => void
  setPollingBooks: (books: ShelfItemBookEntity[]) => void
  setAnalysisStatus: (status: AnalysisStatus) => void
  resetState: () => void
  
  // Computed
  hasSelectedBooks: () => boolean
  getSelectedCount: () => number
}

const initialState: BookSelectionState = {
  selectedBooks: new Set(),
  isLoading: false,
  error: null,
  pollingBooks: [],
}

export const useBookshelfExtractStore = create<BookshelfExtractStore>((set, get) => ({
  ...initialState,
  analysisStatus: "loading",

  // Actions
  setSelectedBooks: (books) =>
    set({ selectedBooks: books }),

  toggleBookSelection: (isbn) =>
    set((state) => {
      const newSelection = new Set(state.selectedBooks)
      if (newSelection.has(isbn)) {
        newSelection.delete(isbn)
      } else {
        newSelection.add(isbn)
      }
      return { selectedBooks: newSelection }
    }),

  setLoading: (loading) =>
    set({ isLoading: loading }),

  setError: (error) =>
    set({ error, isLoading: false }),

  setPollingBooks: (books) =>
    set({ 
      pollingBooks: books,
      // 모든 유효한 ISBN을 자동 선택
      selectedBooks: new Set(
        books.map((book) => book.isbn).filter(Boolean) as string[]
      ),
      isLoading: false,
      error: null,
      analysisStatus: books.length > 0 ? "success" : "empty"
    }),

  setAnalysisStatus: (status) =>
    set({ analysisStatus: status }),

  resetState: () =>
    set({
      ...initialState,
      analysisStatus: "loading",
    }),

  // Computed
  hasSelectedBooks: () => get().selectedBooks.size > 0,
  
  getSelectedCount: () => get().selectedBooks.size,
}))